/* eslint-disable react/prop-types */
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { BASE_URL } from "../../config/api.config";
import { USER_DATA } from "../../config/app.config";

const ShareAffiliateModal = ({ setOpen, open }) => {
  // const affiliateCode = useSelector((state) => state.affiliateCode);
  const promotions = useSelector((state) => state.promotions.socials);
  let userData = {};

  try {
    userData = JSON.parse(localStorage.getItem(USER_DATA) || "{}");
  } catch {
    userData = {};
  }

  let { user_name } = userData;

  const affiliateLink = `${BASE_URL}?af_code=${user_name}`;

  const whatsappUrl = promotions?.Whatsapp?.url;
  const instapUrl = promotions?.Instagram?.url;
  const telegramUrl = promotions?.Telegram?.url;

  // const updatedWhatsappUrl = whatsappUrl
  //   ? whatsappUrl.replace(
  //       /text=[^&]*/g,
  //       `text=${encodeURIComponent(affiliateLink)}`
  //     )
  //   : null;

  // const telegramShareUrl = `https://t.me/share/url?url=${encodeURIComponent(
  //   affiliateLink
  // )}&text=${encodeURIComponent(affiliateLink)}`;

  const copyAffiliateLink = () => {
    const link = `${BASE_URL}?af_code=${user_name}`;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toastr.success("", "Link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  return (
    <>
      {open && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-2sm z-40"
          onClick={() => setOpen(false)}
        ></div>
      )}

      <div
        className={`
          fixed bottom-0 left-0 right-0 z-50
          flex justify-center
          transition-transform duration-300
          ${open ? "translate-y-0" : "translate-y-full"}
        `}
      >
        <div className="bg-white w-full lg:w-[50%] relative  rounded-t-2xl shadow-lg modal_affi">
          <div className="modal-header">
            <h5 className="modal-title">Share Affiliate link or Code </h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            />
          </div>
          <div className="modal-body">
            <div className="share-link-img-sec">
              <img
                src="/af-share-img.svg"
                alt="af-share-img"
                style={{ width: "100%" }}
              />
            </div>
            <div className="af-share-link-wrapper">
              <p>Share Link</p>
              <div className="af-share-link-sec">
                <span>
                  {BASE_URL}?af_code={user_name}
                </span>
                <button
                  className="thm-but btn-gradient"
                  onClick={copyAffiliateLink}
                >
                  Copy
                </button>
              </div>
            </div>
            {(promotions?.Whatsapp?.is_active ||
              promotions?.Telegram?.is_active ||
              promotions?.Instagram?.is_active) && (
              <div className="af-share-link-wrapper">
                <div className="affilate-cmn-footer">
                  <div className="shre-text-title">
                    <p>Share this link via</p>
                  </div>
                  <div className="af-share-social-link-sec">
                    {promotions?.Whatsapp?.is_active && (
                      <a
                        href={`https://wa.me/?text=${encodeURIComponent(affiliateLink)}`}
                        target="_blank"
                        className=""
                      >
                        <img src="/what.webp" alt="whatsapp" />
                      </a>
                    )}
                    {promotions?.Telegram?.is_active && (
                      <a
                        href={`https://t.me/share/url?url=${encodeURIComponent(affiliateLink)}`}
                        target="_blank"
                      >
                        <img src="/instagram-share.svg" alt="instagram-share" />
                      </a>
                    )}
                    {promotions?.Instagram?.is_active && (
                      <a href="https://www.instagram.com/" target="_blank">
                        <img src="/telegram-share.svg" alt="telegram-share" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareAffiliateModal;
